import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import InviteCard from "./components/inviteCard/InviteCard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const InvitesPage = () => {
  const { username: urlUsername } = useParams();
  const username = urlUsername || localStorage.getItem("username");
  const userEmail = localStorage.getItem("userEmail");
  const token = localStorage.getItem("token");

  const [userProfiles, setUserProfiles] = useState({});
  const [projectData, setProjectData] = useState({});

  const [activeTab, setActiveTab] = useState("sent");
  const [sentInvites, setSentInvites] = useState([]);
  const [receivedInvites, setReceivedInvites] = useState([]);

  useEffect(() => {
  const fetchInvites = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/invites/get`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      const sent = data.sent || [];
      const received = data.received || [];

      setSentInvites(sent);
      setReceivedInvites(received);

      // Fetch all involved emails
      const allEmails = [
        ...sent.map((i) => i.recipientEmail),
        ...received.map((i) => i.senderEmail),
      ];
      const uniqueEmails = Array.from(new Set(allEmails));

      // Fetch user profiles
      const profilePromises = uniqueEmails.map(async (email) => {
        try {
          const res = await fetch(`${BACKEND_URL}/user/${encodeURIComponent(email)}`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          const data = await res.json();
          return { email, profile: data };
        } catch (err) {
          console.warn(`❌ Failed to fetch profile for ${email}:`, err.message);
          return { email, profile: null }; // So it still maps
        }
      });


      const results = await Promise.all(profilePromises);
      const profileMap = {};
      results.forEach(({ email, profile }) => {
        profileMap[email] = profile;
      });

      setUserProfiles(profileMap);

      // Get unique project IDs
const allProjectIds = [
  ...sent.map((i) => i.projectId),
  ...received.map((i) => i.projectId),
];
const uniqueProjectIds = Array.from(new Set(allProjectIds));

// Fetch all project details
const projectPromises = uniqueProjectIds.map(async (projectId) => {
  try {
    const res = await fetch(`${BACKEND_URL}/projects/${projectId}/details`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    return { projectId, project: data };
  } catch (err) {
    console.warn(`❌ Failed to fetch project ${projectId}:`, err.message);
    return { projectId, project: null };
  }
});

const projectResults = await Promise.all(projectPromises);

// 🔥 Step 3: Build a map of projectId → project object
const projectMap = {};
projectResults.forEach(({ projectId, project }) => {
  projectMap[projectId] = project;
});

setProjectData(projectMap); // 🧠 You’ll need to add useState for this

    } catch (err) {
      console.error("❌ Failed to fetch invites or user profiles:", err.message);
    }
  };

  fetchInvites();
}, [userEmail]);


  const handleAcceptInvite = async (invite) => {
    try {
      const res = await fetch(`${BACKEND_URL}/invites/accept/${invite.id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      console.log("✅ Invite accepted:", data.message);

      // Refetch invites or optimistically update state
      window.location.reload(); // or call fetchInvites() again

    } catch (err) {
      console.error("❌ Failed to accept invite:", err.message);
    }
  };


  const handlePassInvite = async (invite) => {
  try {
    const res = await fetch(`${BACKEND_URL}/invites/pass/${invite.id}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();
    console.log("🚫 Invite passed:", data.message);

    // Refetch invites or optimistically update state
    window.location.reload(); // or call fetchInvites() again

  } catch (err) {
    console.error("❌ Failed to pass invite:", err.message);
  }
};


  return (
    <div className="max-w-4xl mx-auto mt-10 px-4">
      <h1 className="text-2xl font-semibold text-gray-800 mb-6">Invites</h1>

      <div className="flex border-b border-gray-200 mb-6">
        <button
          className={`px-4 py-2 text-sm font-medium ${
            activeTab === "sent"
              ? "border-b-2 border-gray-800 text-gray-800"
              : "text-gray-600 hover:text-gray-800"
          }`}
          onClick={() => setActiveTab("sent")}
        >
          Sent
        </button>
        <button
          className={`ml-4 px-4 py-2 text-sm font-medium ${
            activeTab === "received"
              ? "border-b-2 border-gray-800 text-gray-800"
              : "text-gray-600 hover:text-gray-800"
          }`}
          onClick={() => setActiveTab("received")}
        >
          Received
        </button>
      </div>

      <div className="space-y-4">
        {activeTab === "sent" && sentInvites.length > 0 ? (
  sentInvites.map((invite) => (
    <InviteCard
      key={invite.id}
      type="sent"
      invite={invite}
      userProfile={userProfiles[invite.recipientEmail]}
      project={projectData[invite.projectId]}
    />
  ))
) : activeTab === "sent" ? (
  <div className="p-4 bg-gray-100 rounded-md text-gray-600 text-sm">
    No sent invites to show.
  </div>
) : null}

{activeTab === "received" && receivedInvites.length > 0 ? (
  receivedInvites.map((invite) => (
    <InviteCard
      key={invite.id}
      type="received"
      invite={invite}
      userProfile={userProfiles[invite.senderEmail]}
      project={projectData[invite.projectId]}
      onAccept={handleAcceptInvite}
      onPass={handlePassInvite}
    />
  ))
) : activeTab === "received" ? (
  <div className="p-4 bg-gray-100 rounded-md text-gray-600 text-sm">
    No received invites yet.
  </div>
) : null}
      </div>
    </div>
  );
};

export default InvitesPage;